module.exports = __webpack_public_path__ + "img/9.6ac4d145.jpg";